import { t } from "i18next"
import type { AgentWorkspaceDisplayLayout } from "@callcenter/services"

import compactViewIllustration from "./icons/compact-view.svg"
import fullScreenIllustration from "./icons/full-screen.svg"

type AgentWorkspaceLayoutOption = {
  value: AgentWorkspaceDisplayLayout
  title: string
  description: string
  illustration: string
}

export const AGENT_WORKSPACE_LAYOUT_OPTIONS: Array<AgentWorkspaceLayoutOption> = [
  {
    value: "compact",
    title: t("userProfile_userProfileSidePanel_interfaceSettingsLabel_compactViewLabel"),
    description: t("userProfile_userProfileSidePanel_interfaceSettingsLabel_compactViewDescription"),
    illustration: compactViewIllustration
  },
  {
    value: "full_screen",
    title: t("userProfile_userProfileSidePanel_interfaceSettingsLabel_fullScreenLabel"),
    description: t("userProfile_userProfileSidePanel_interfaceSettingsLabel_fullScreenDescription"),
    illustration: fullScreenIllustration
  }
]
